import React from 'react';
import { useRouteError, Link } from 'react-router-dom';
import { Box, Heading, Text, Button, Flex } from '@chakra-ui/react';

export default function ErrorBoundary() {
  const error = useRouteError();
  console.error(error);

  return (
    <Flex minHeight="80vh" alignItems="center" justifyContent="center">
      <Box textAlign="center" p={8} maxW="500px" w="100%">
        <Heading as="h1" size="xl" color="red.500" mb={4}>
          出错了！
        </Heading>
        <Text fontSize="lg" mb={4}>
          {error.statusText || error.message || '发生了一个未知错误'}
        </Text>
        <Text color="gray.500" mb={6}>
          请尝试刷新页面或返回首页
        </Text>
        <Flex justifyContent="center" gap={4}>
          <Button onClick={() => window.location.reload()} colorScheme="blue">
            刷新页面
          </Button>
          <Button as={Link} to="/" colorScheme="gray">
            返回首页
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
} 